module.exports = __webpack_public_path__ + "static/img/02_bart_jansen.8f062dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moments/02_bart_jansen.png
// module id = 7pj7
// module chunks = 1